import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import { useClientFetch } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import { fetchOrganizacie } from '../client/external/ciselniky/organizaciaClient';
import Organizacia from '../model/ciselniky/Organizacia';
import Uuid from '../model/Uuid';

interface ReturnType {
  organizacie: Organizacia[];
  organizacieStatus: ClientStatus;
}

export default (
  typ: OrganizacnaSkupinaEnum,
  platna: boolean = undefined,
  ldap: boolean = undefined,
  legislativna: boolean = undefined,
  ids: Uuid[] = [],
  execute = true,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    fetchOrganizacie,
    [typ, ids, ldap, undefined, legislativna, platna, undefined, execute],
    [],
  );
  return {
    organizacie: data,
    organizacieStatus: status,
  };
};
